module.exports = __webpack_public_path__ + "img/reference27.41622879.jpg";